import { render, staticRenderFns } from "./Matrix3.vue?vue&type=template&id=5d341128&scoped=true"
import script from "./Matrix3.vue?vue&type=script&lang=js"
export * from "./Matrix3.vue?vue&type=script&lang=js"
import style0 from "./Matrix3.vue?vue&type=style&index=0&id=5d341128&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d341128",
  null
  
)

export default component.exports